import { Box, Typography } from '@mui/material';
import ImageNotSupportedOutlined from '@mui/icons-material/ImageNotSupportedOutlined';
import { useTranslation } from 'react-i18next';

interface EmptyImageProps {
  height?: number;
  text?: string;
}

export default function EmptyImage({ height = 270, text }: EmptyImageProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        height,
        bgcolor: 'grey.100',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'grey.500',
        gap: 1,
      }}
    >
      <ImageNotSupportedOutlined fontSize="large" />
      <Typography variant="body2">
        {text ?? String(t('com.msg.이미지가 없습니다.', '이미지가 없습니다.'))}
      </Typography>
    </Box>
  );
}
